import { For, type JSX, Match, Switch } from 'solid-js';
import { t } from '../i18n';
import type { BlockerGuidance as Guidance } from '../lib/blockers';

// WHAT TO DO about a blocker, in plain language (#6679) — the numbered steps the guidance
// sweep wrote for THIS row, above the answer box. Presenter: the card decides whether the
// row is open and whether it offers choices.
//
// FOUR STATES, and only one of them is quiet:
//   - steps            -> the numbered list, and which model wrote it;
//   - not tried yet    -> say the steps are being worked out, and that the person can
//                         answer in their own words NOW; the sweep runs every ten minutes,
//                         and a page that waited on it would be the dead end this removes;
//   - tried, nothing   -> say so plainly and point at the answer box, never "No suggestions";
//   - offers choices   -> nothing: a judgement with named outcomes is answered by picking
//                         one, and the sweep never writes steps for it.
//
// The steps are MODEL OUTPUT rendered as text, never as markup: Solid escapes them, and
// no step is ever read back by the platform. A closed row keeps its steps, because the
// steps a person followed are part of why it closed; it shows no pending line.

export function BlockerGuidance(props: {
  readonly guidance: Guidance | null;
  /** True while the blocker is open — only an open row is still owed steps. */
  readonly open: boolean;
  /** True when the row offers CHOICES: the sweep never writes steps for those. */
  readonly offersChoices: boolean;
}): JSX.Element {
  return (
    <Switch>
      <Match when={props.guidance?.kind === 'steps' ? props.guidance : null}>
        {(g) => (
          <div class="blocker-guidance">
            <h3 class="blocker-guidance__title">{t('blockers.guidance_title')}</h3>
            <ol class="blocker-guidance__steps">
              <For each={g().steps}>{(step) => <li>{step}</li>}</For>
            </ol>
            <p class="card__desc">{t('blockers.guidance_by', { model: g().model })}</p>
          </div>
        )}
      </Match>
      <Match when={props.open && !props.offersChoices && props.guidance === null}>
        <p class="card__desc">{t('blockers.guidance_pending')}</p>
      </Match>
      <Match when={props.open && props.guidance?.kind === 'none'}>
        <p class="card__desc">{t('blockers.guidance_none')}</p>
      </Match>
    </Switch>
  );
}
